/* eslint-disable max-len */
export default {
  title: 'O nás',
  ourClients: 'Naši klienti',
  description: 'Naše společnost vznikla v roce 2002 a působí  v oboru staveb v oblasti Středočeského kraje a Prahy. Vlastníme nejmodernější strojový park který neustále rozšiřujeme a díky pravidelným investicím do nejrůznějšího stavebního vybavení a zařízení jsme schopni zrealizovat prakticky jakoukoliv stavební zakázku.',
};
